import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../service/api_service';
import * as $ from 'jquery';
import { Subscription } from 'rxjs'; 

@Component({
    selector: 'areabeetmaster',
    template: require('./areabeetmaster.component.html'),
    styles: [],
    viewProviders: [ApiService]
})
export class AreaBeetMasterComponent implements OnInit {

    @ViewChild('stockistEdit') stockistEdit;
    viewModal: boolean = false;
    editModal: boolean = false;
    addModal: boolean = false;
    static parameters = [ApiService, Router]
    hqData: any = [];
    hqArea: any = [];
    additionalArea: string;


    private columnDefs;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    constructor(private apiService: ApiService, private router: Router) {
        var self = this;
        this.apiService = apiService;
        this.columnDefs = [
            { headerName: 'Head Qtr', field: "HQName" },
            { headerName: 'State', field: "HQName" },
            { headerName: '	Total Additional Area', field: "totalArea" },
            {
                headerName: 'Action', field: "Action", width: 100, pinned: "right", cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `
          <div class="grid_actions">
              <span class="viewBtn grid_actions_item"><i class="icon-view"></i></span>


              <span class="addBtn grid_actions_item" data-target="#stockistEdit" data-toggle="modal"><i class="icon-add"></i></span>
          </div>
         
            `;
                    var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
                    // var editButton = eDiv.querySelectorAll('.editBtn')[0];
                    var addButton = eDiv.querySelectorAll('.addBtn')[0];
                    // if(self.editModal){
                    //   console.log('hello');
                    //   editButton.setAttribute("disabled", "disabled");
                    // }
                    viewButton.addEventListener('click', function () {
                        //self.router.navigate(['arealistmaster'])
                        self.router.navigate(['/arealistmaster'], { queryParams: { id: params.data.HQID } });
                    })
                    // viewButton.addEventListener('click', function () {
                    //     self.router.navigate(['arealistmaster'])
                    // });

                    /* editButton.addEventListener('click', function () {
                        self.viewModal = false;
                        self.editModal = true;
                        self.addModal = false;
                        self.formValueSet(params.data);

                    }) */

                    addButton.addEventListener('click', function () {
                        self.viewModal = false;
                        self.editModal = false;
                        self.addModal = true;
                        self.formValueSet(params.data);
                    })
                    return eDiv
                }
            },
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }

    additionalAreaForm = new FormGroup({
        hqName: new FormControl('', [Validators.required]),
        add_Area: new FormControl('', [Validators.required]),

    });
    ngOnInit() {
        this.GetHeadQuarter();

    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.sizeColumnsToFit();
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'sales' });
    }

    formValueSet(data) {
        console.log('this.additionalAreaForm.value.EmployeeName', data);
        this.additionalAreaForm.controls['hqName'].setValue(data.HQName);
        this.hqArea.HQID = data.HQID;

    }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }
    GetHeadQuarter() {
       this.busy = this.apiService.getAreaCountHQWise().subscribe((res: any) => {
            this.hqData = res.data;
            setTimeout(function (self) {
                self.api.sizeColumnsToFit();
            }, 100, this);
        })

    }

    hqDetails(item) {

        this.hqArea = item;
    }

    saveAdditionalArea() {
        // let data: any = this.additionalAreaForm.value;
        var Area = (this.additionalAreaForm.value.add_Area? this.additionalAreaForm.value.add_Area: "").trim();
        if(Area.length == 0){
            alert("Area can not be blank.");
            return false;
        }
        var data = {
            HQID: this.hqArea.HQID,
            addtionalArea: Area,
        }
        this.busy = this.apiService.saveAdditionalArea(data).subscribe((res: any) => {            
            if(res.data[0].flag == 1){
                alert(res.data[0].msg);
                this.additionalAreaForm.reset();
                this.hqArea = [];
                $("#stockistEdit .close").click();
                this.GetHeadQuarter();
            } else {
                alert(res.data[0].msg);
            }
        })
    }
}